import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { createPinia } from 'pinia'
import { i18nVue, loadLanguageAsync } from 'laravel-vue-i18n'
import Bugsnag from '@bugsnag/js'
import { ZiggyVue, route } from '../../vendor/tightenco/ziggy/dist/index.esm.js'
import { Ziggy } from './ziggy'

// Store current page data globally for route helper
let currentPageData: any = null

createInertiaApp({
    title: (title) => `${title} - SONNENGLAS Partner Portal`,
    resolve: (name) => {
        const pages = import.meta.glob('./pages/**/*.vue', { eager: true })
        const page = pages[`./pages/${name}.vue`]
        return page.default || page
    },
    setup: async ({ el, App, props, plugin }) => {
        const pinia = createPinia()
        
        // Store current page data globally
        currentPageData = props.initialPage
        
        // Update page data on navigation
        if (typeof window !== 'undefined') {
            (window as any).__inertiaPageData = props.initialPage
            
            // Listen for Inertia navigation events to update page data
            document.addEventListener('inertia:navigate', (event: any) => {
                const page = event.detail.page
                currentPageData = page;
                (window as any).__inertiaPageData = page
            })
        }
        
        // Initialize Bugsnag only in production environment
        const laravelEnv = props.initialPage.props.app?.env || 'local'
        if (laravelEnv === 'production') {
            Bugsnag.start({
                apiKey: '5450119c472fe14fa5ccc408f152121a',
                maxBreadcrumbs: 10,
            })
        }
        
        // Initialize with the correct locale from Inertia props
        const currentLocale = props.initialPage.props.locale || 'de'
        console.log('Current locale detected:', currentLocale)
        
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(i18nVue, {
                resolve: async (lang: string) => {
                    const langs = import.meta.glob('../../lang/*.json')
                    return await langs[`../../lang/${lang}.json`]()
                }
            })
            .use(ZiggyVue, Ziggy)

        // Make route() available for inject() in script setup
        // Provide a route function with Ziggy configuration pre-bound
        app.provide('route', (name?: string, params?: any, absolute?: boolean) => {
            return route(name, params, absolute, Ziggy)
        })

        // Set global locale after i18n is initialized
        await loadLanguageAsync(currentLocale)

        return app.mount(el)
    },
    progress: {
        color: '#f7931e',
    },
})
